import { updateChoiceSuccess } from '@gcc/configurator/dist/actions/choiceActions';

export const regionalPrice = (regionalInstallPrice, regionalInstallSelection) => (dispatch) => {
  if (regionalInstallSelection) {
    const { id, optionId } = regionalInstallSelection;
    if (regionalInstallPrice) {
      dispatch(updateChoiceSuccess(optionId, id, regionalInstallPrice, true));
    }
  }
};